import {HTTP_FORBIDDEN} from "./http.error";
import ClientError from "./client.error";

export default class ForbiddenError extends ClientError {
    /**
     * Constructor
     * @param message {string}
     * @param [response] {*}
     * @param [previous] {Error}
     */
    constructor(message, response, previous) {
        super(HTTP_FORBIDDEN, message, response, previous);
        this.name = 'ForbiddenError';
    }
}